"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regex_split_1 = require("./regex_split");
exports.urlTransformer = (transformer) => (pattern) => (fullUrl) => {
    return regex_split_1.default(pattern)(fullUrl)
        .map(transformer)
        .join("");
};
exports.default = exports.urlTransformer;
//# sourceMappingURL=url_transformer.js.map